import { createAsyncThunk } from "@reduxjs/toolkit";
import { SubscriptionServices } from '@/services/api/cresivoxServer';
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { REDUCER_NAME } from "./Types";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const subscriptiontUpgrade = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { planId: string }, // ✅ FIXED
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("subscriptiontUpgrade"),
  // @ts-expect-error
  async (payload, { rejectWithValue }) => {
    try {
      const response = await SubscriptionServices.subscriptiontUpgrade(payload);

      if (!response) {
        return rejectWithValue({ message: "No response received" });
      }

      const { httpStatusCode, data, message } = response;

      if (httpStatusCode === httpStatusCodes.SUCCESS_OK) {
        return { data: { build: data, message } };
      }

      return rejectWithValue({ httpStatusCode, message });

    } catch (error: any) {

      return rejectWithValue({
        message: error?.response?.data?.message || "Request failed",
      });
    }
  }
);
